<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :submission="submission"
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:50px;">
            <form @submit.prevent="saveStyle">
                <h2>ENTER STYLE: <span style="font-size:1.0rem; font-weight:normal;">(click on the style as it populates below)</span></h2>
                <autocomplete
                    :source="styles"
                    placeholder="Select Style..."
                    @selected="selectStyle"
                    style="width:40%;">
                </autocomplete>
                <br />
                <br />
                <button class="btn-round-red" type="submit">NEXT STEP ></button>
            </form>
        </div>
    </div>
</template>

<script>
import Autocomplete from "vuejs-auto-complete";
export default {
    components: {
        Autocomplete
    },
    data() {
        return {
            activity: "",
            styles: [],
            styleSelection: "",
            submission: {},
        }
    },
    props: ['ppId'],
    created() {
        axios.get(`/api/getStylesForAutoComplete`).then(response => {
            this.styles = response.data;
        });
        axios.get(`/api/getSubmission/${this.ppId}`).then(response => {
            this.submission = response.data;

            this.activity = this.submission.activity.activity;
        });
    },
    methods: {
        saveStyle() {
            let data = {
                id: this.ppId,
                styleInfo: this.styleSelection
            };

            axios.post(`/api/saveStyleToSubmission`, data).then(response => {
                this.$router.push({
                    name: "PriceWorkflowSkuSelect",
                    params: { ppId: this.ppId }
                });
            });
        },
        selectStyle(result) {
            this.styleSelection = result.value;
        }
    }
}
</script>

<style scoped>
    #standard-styling {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }
</style>
